/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading components
 * -----------------------------------------------------------------------------------------------------------
 */
import auth from 'src/router/auth'
import Role from '../Role'
import NewRole from '../NewRole'
import EditRole from '../EditRole'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Define component
 * -----------------------------------------------------------------------------------------------------------
 */
export default [
  {
    path: '/roles',
    name: 'role',
    component: Role,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/roles/create',
    name: 'new-role',
    component: NewRole,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/roles/edit/:id',
    name: 'edit-role',
    component: EditRole,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/role/routes/index.js